import { includes } from 'lodash';
import quoteTypes from 'commons-vehicle/Quote/actions/quoteActionTypes.js';
import purchaseMethodsTypes from 'commons-vehicle/PurchaseMethods/actions/purchaseMethodsActionTypes.js';
import * as PurchaseMethodsService from 'commons-vehicle/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js';
import QuoteModel from 'commons-vehicle/Quote/models/QuoteModel.js';

export default function quoteReducer(state = new QuoteModel(), action) {
    switch (action.type) {
        case quoteTypes.SET_QUOTE:
            return action.quote;

        case quoteTypes.SET_QUOTE_MODIFIED:
            return state.set('modified', true);

        case quoteTypes.SET_QUOTE_REVISION:
            return state.set('revision', action.revision);

        case quoteTypes.SET_QUOTE_MODEL_YEAR:
            return state.set('vehicle', action.modelYear.getVehicleFromConfiguration());

        case quoteTypes.SET_QUOTE_VEHICLE:
            return state.set('vehicle', action.vehicle);

        case quoteTypes.SET_LEAD_TYPE:
            return state.set('leadType', action.leadType);

        case quoteTypes.SET_STATUS:
            return state.set('status', action.status);

        case quoteTypes.SET_SECURITY_TOKEN:
            return state.set('securityToken', action.securityToken);

        case quoteTypes.SET_QUOTE_PURCHASE_METHODS:
            return state.setIn(['vehicle', 'purchaseMethods'], action.purchaseMethods);

        case purchaseMethodsTypes.SELECT_PURCHASE_METHOD:
            return state
                .setIn(
                    ['vehicle', 'purchaseMethods'],
                    PurchaseMethodsService.selectPurchaseMethod(state.vehicle.purchaseMethods, action.purchaseMethod)
                )
                .set('modified', true);

        case purchaseMethodsTypes.SELECT_TERM:
            return state
                .setIn(
                    ['vehicle', 'purchaseMethods'],
                    PurchaseMethodsService.selectTerm(state.vehicle.purchaseMethods, action.term)
                )
                .set('modified', true);

        case purchaseMethodsTypes.SELECT_PAYMENT_FREQUENCY:
            return state
                .setIn(
                    ['vehicle', 'purchaseMethods'],
                    PurchaseMethodsService.selectPaymentFrequency(
                        state.vehicle.purchaseMethods,
                        action.paymentFrequency.value
                    )
                )
                .set('modified', true);

        case purchaseMethodsTypes.SET_CASH_DOWN:
            return state
                .setIn(
                    ['vehicle', 'purchaseMethods'],
                    PurchaseMethodsService.setCashDown(state.vehicle.purchaseMethods, action.cashDown)
                )
                .set('modified', true);

        case purchaseMethodsTypes.SET_TRADE_IN: {
            return state.vehicle.purchaseMethods.tradeIn !== action.tradeIn
                ? state
                      .setIn(
                          ['vehicle', 'purchaseMethods'],
                          PurchaseMethodsService.setTradeIn(state.vehicle.purchaseMethods, action.tradeIn)
                      )
                      .set('modified', true)
                : state;
        }
        case purchaseMethodsTypes.SET_LIEN:
            return state.vehicle.purchaseMethods.lien !== action.lien
                ? state
                      .setIn(
                          ['vehicle', 'purchaseMethods'],
                          PurchaseMethodsService.setLien(state.vehicle.purchaseMethods, action.lien)
                      )
                      .set('modified', true)
                : state;

        case purchaseMethodsTypes.SET_TAXES_INCLUDED:
            return state
                .setIn(
                    ['vehicle', 'purchaseMethods'],
                    PurchaseMethodsService.setTaxesIncluded(state, action.taxesIncluded)
                )
                .set('modified', true);

        case purchaseMethodsTypes.SELECT_KM_PLAN:
            return state
                .setIn(
                    ['vehicle', 'purchaseMethods'],
                    PurchaseMethodsService.selectKMPlan(state.vehicle.purchaseMethods, action.kmPlan.value)
                )
                .set('modified', true);

        default:
            if (includes(purchaseMethodsTypes.QUOTE_UPDATE_TYPES, action.type)) {
                return state.set('modified', true);
            }
            return state;
    }
}
